/**
 * Tiny wrapper around localStorage for the JWT session token.
 *
 * The token is the only auth state we persist in the browser. The user object
 * is always re-fetched from `GET /auth/me` on load so it can't go stale (e.g.
 * if an admin flag is flipped in the DB).
 */

const TOKEN_KEY = "al-life-auth-token";

export function getToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setToken(token: string): void {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {
    // Private-mode / storage-disabled: session simply won't persist.
  }
}

export function clearToken(): void {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    // ignore
  }
}
